import Typography from '@mui/material/Typography';
import { formatDuration } from './format-duration';
import Modal from '../Modal/Modal';
import { ButtonPrimary } from '../inputs/buttons/primary/primary';

export type SessionTimeoutDialogProps = {
  open: boolean;
  remainingSeconds: number;
  onStaySignedIn: () => void;
  onDismiss: () => void;
};

/**
 * The warning both hosts show. Sized in absolute units rather than rem: the server-rendered
 * pages declare a 14px root, so a rem here would count down in a different size than it does
 * in the SPA — the same drift the theme's pxToRem exists to prevent.
 */
export function SessionTimeoutDialog(props: SessionTimeoutDialogProps) {
  return (
    <Modal
      open={props.open}
      onClose={props.onDismiss}
      maxWidth="xs"
      dialogTitle={
        <Typography variant="h4" component="h2" color="text.primary">
          Your session is about to expire
        </Typography>
      }
      actions={
        <ButtonPrimary variant="contained" fullWidth onClick={props.onStaySignedIn}>
          Stay signed in
        </ButtonPrimary>
      }
    >
      <Typography
        variant="h1"
        component="p"
        color="text.primary"
        role="timer"
        aria-live="off"
        sx={{ mt: 1, mb: 2, fontSize: '48px', textAlign: 'center', fontVariantNumeric: 'tabular-nums' }}
      >
        {formatDuration(props.remainingSeconds)}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        We keep you signed in while you're using the app, but it looks like you've been away for a little while. To keep
        your information safe, you'll be signed out when the clock above reaches zero.
      </Typography>
    </Modal>
  );
}
